import React from 'react';

function Failed() {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='8' fill='#FFF1F0' />
      <path
        d='M18.0258 22.3249H9.22612C8.01111 22.3249 7.02615 21.3399 7.02611 20.1249L7.02588 11.8751C7.02584 10.6601 8.01083 9.67505 9.22588 9.67505H22.4254C23.6404 9.67505 24.6254 10.6595 24.6254 11.8745L24.6255 15.725M7.57546 13.5249H24.0755M21.699 22.1235L23.3364 20.4861M23.3364 20.4861L24.9738 18.8486M23.3364 20.4861L21.699 18.8486M23.3364 20.4861L24.9738 22.1235'
        stroke='#F5222D'
        stroke-width='1.8'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default Failed;
